import React from 'react'
import OrganImage from './OrganImage'
import OrganText from './OrganText'
import OrganCard from './OrganCard'
import Scroll from '../../pages/Scroll/Scroll'
import Footer from '../../pages/Footer/Footer'

const OrganTransplant = () => {
  return (
    <>
         <OrganImage/>
         <OrganText/>
         <OrganCard/>
         <Scroll/>
         <Footer/>
    </>
  )
}

export default OrganTransplant
